/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedStoresResponseDto } from '../../models/paginated-stores-response-dto';

export interface StoreControllerFindMany$Params {
  /**
   * Field to filter by exact value
   */
  field?: string;
  order?: 'asc' | 'desc';

  /**
   * Field to order by (allowed values depend on the endpoint)
   */
  orderBy?: string;

  /**
   * Search key
   */
  searchKey?: string;

  /**
   * Exact value to filter the field by
   */
  value?: string;
  page: number;
  size: number;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function storeControllerFindMany(
  http: HttpClient,
  rootUrl: string,
  params: StoreControllerFindMany$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<PaginatedStoresResponseDto>> {
  const rb = new RequestBuilder(rootUrl, storeControllerFindMany.PATH, 'get');
  if (params) {
    rb.query('field', params.field, {});
    rb.query('order', params.order, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('searchKey', params.searchKey, {});
    rb.query('value', params.value, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedStoresResponseDto>;
    })
  );
}

storeControllerFindMany.PATH = '/api/v1/stores';
